import React, { useState } from "react";
import { TrendingUp } from "lucide-react";
import { useBranding } from "@/context/BrandingContext";

const LEAK = 0.015;     // conservative skimming rate (services only, excludes product/other loss)
const RECOVERY = 0.85;  // share BCS recovers

export default function ROICalculator() {
  const { money } = useBranding();
  const [salons, setSalons] = useState(20);
  const [cuts, setCuts] = useState(400);
  const [ticket, setTicket] = useState(28);
  const annual = Math.round(salons * cuts * 52 * ticket * LEAK * RECOVERY);
  const field = "mt-1 w-full rounded-lg bg-[#171E2E] border border-[#2A3550] px-3 py-2 text-sm text-slate-100 focus:border-[#38BDF8] focus:outline-none";

  return (
    <div className="surface-card p-6" data-testid="roi-calculator">
      <div className="flex items-center gap-2">
        <TrendingUp className="h-5 w-5 text-emerald-400" />
        <h2 className="font-display text-lg font-medium">What could you be recovering?</h2>
      </div>
      <p className="mt-1 text-sm text-slate-400">Enter your own numbers — the estimate uses a conservative <strong className="text-slate-300">1.5% skimming rate</strong> (services only, not product or other loss) and an 85% recovery rate.</p>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <label className="block text-xs uppercase tracking-[0.15em] text-slate-400 font-semibold">Salons
          <input type="number" min="1" value={salons} onChange={(e) => setSalons(Math.max(0, +e.target.value))} className={field} data-testid="roi-salons" />
        </label>
        <label className="block text-xs uppercase tracking-[0.15em] text-slate-400 font-semibold">Cuts / week / salon
          <input type="number" min="0" value={cuts} onChange={(e) => setCuts(Math.max(0, +e.target.value))} className={field} data-testid="roi-cuts" />
        </label>
        <label className="block text-xs uppercase tracking-[0.15em] text-slate-400 font-semibold">Avg ticket
          <input type="number" min="0" value={ticket} onChange={(e) => setTicket(Math.max(0, +e.target.value))} className={field} data-testid="roi-ticket" />
        </label>
      </div>
      <div className="mt-5 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-5 py-4">
        <div className="text-xs uppercase tracking-[0.15em] text-emerald-300/80 font-semibold">Estimated annual recovery</div>
        <div className="mt-1 font-display text-3xl sm:text-4xl font-light text-emerald-300" data-testid="roi-result">{money(annual)}</div>
        <div className="mt-1 text-xs text-slate-400">Illustrative — for co-evaluation, not a guarantee.</div>
      </div>
    </div>
  );
}
